import { render, staticRenderFns } from "./ReferralDetailSummary.vue?vue&type=template&id=1a66b965&"
import script from "./ReferralDetailSummary.vue?vue&type=script&lang=ts&"
export * from "./ReferralDetailSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralDetailSummary.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports